<template>
  <el-container>
    <el-header style="height: 35px; border-bottom: 1px solid #eee">
      <el-row type="flex" justify="center" align="middle">
        <el-popover v-if="vers.length" placement="bottom-start" trigger="hover" v-model="showSelect">
          <el-row v-for="(item, index) in vers" :key="item.id" :class="index ? 'top-pad' : ''" type="flex" align="middle">
            <el-tag type="success" size="mini" effect="dark" hit>{{ item.ver }}.0 版</el-tag>
            <el-link class="left-pad" @click="switchVer(item)" :underline="false" :disabled="curr && curr.id == item.id">
              {{ item.submitUserName }} 于 <small>{{ item.submitTime }}</small> 提交
            </el-link>
          </el-row>
          <el-link type="primary" slot="reference" :underline="false">
            <span v-if="curr">
              <el-tag type="success" size="mini" effect="dark" hit>{{ curr.ver }}.0 版</el-tag> {{ curr.submitUserName }} 于 <small>{{ curr.submitTime }}</small> 提交
            </span>
            <span v-else>共有 {{ vers.length }} 个版本，请选择！</span>
          </el-link>
        </el-popover>
        <span v-if="!loading && !vers.length" class="danger">暂无已提交版本</span>
      </el-row>
    </el-header>
    <el-main style="position: absolute; top: 35px; bottom: 0px; left: 0; right: 0">
      <Ide ref="ide" readonly />
    </el-main>
  </el-container>
</template>
<script>
  export default {
    props: {
      mr: Object,
    },
    components: {
      Ide: () => import("./_ide.vue"),
    },
    data() {
      return {
        loading: false,
        vers: [],
        curr: null,
        showSelect: false,
      };
    },
    watch: {
      mr() {
        if (this.$refs.ide && this.$refs.ide.meta.inited) {
          this.$refs.ide.closeFile();
        }
        this.load();
      },
    },
    mounted() {
      // this.load();
    },
    methods: {
      load() {
        this.loading = true;
        this.vers = [];
        this.curr = null;

        if (!this.mr) {
          this.loading = false;
          return;
        }
        this.$api.MrVer.query({ mainId: this.mr.id })
          .then((res) => {
            this.vers = res.items.filter((i) => !i.ifEditing).sort((a, b) => b.ver - a.ver);
            if (this.vers.length) {
              this.switchVer(this.vers[0]);
            }
            this.$utils.log("加载所有版本", this.vers);
          })
          .finally(() => {
            this.loading = false;
          });
      },
      switchVer(ver) {
        this.showSelect = false;
        this.curr = ver;
        this.$api.MrVer.get(ver.id).then((res) => {
          this.$refs.ide.openFile(res.content, false);
        });
      },
      unInit() {
        this.$refs.ide.meta.inited = false;
      },
    },
  };
</script>
